import { VStack, View, useBreakpointValue } from "@gluestack-ui/themed";
import { createPortal } from "react-dom";
import { forwardRef, useImperativeHandle, useState } from "react";

import { SelectListProps, SelectListRef } from "./types";

import { SelectListScreen } from "./list";

import { styles } from "./styles";

export const SelectList = forwardRef<SelectListRef, SelectListProps>(
  (props, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    const isMobile = useBreakpointValue({
      base: true,
      md: false
    });

    useImperativeHandle(ref, () => {
      return {
        open() {
          setIsOpen(true);
        },
        close() {
          setIsOpen(false);
        }
      };
    }, []);

    const handleClose = () => {
      setIsOpen(false);
    };

    if (!isOpen) {
      return null;
    }

    return createPortal(
      <>
        <div
          style={styles.wrapper as React.CSSProperties}
          onClick={handleClose}
        />
        <div style={{...styles.container, width: isMobile ? '100%' : 450} as React.CSSProperties}>
          <VStack w="$full" h="100%">
            <View p="$4" flex={1}>
              <SelectListScreen {...props} onCancel={handleClose} />
            </View>
          </VStack>
        </div>
      </>,
      document.body
    );
  }
);
